import api from '@disco/api/server'
import { copyToDisco } from '@disco/state-management/actions/ExplorerActions'
import { loadBatch } from '@disco/state-management/actions/PlaylistTrackActions'
import { getShortlists } from '@disco/state-management/selectors/shortlists'
import { getTrack } from '@disco/state-management/selectors/tracks'
import { isAggregatedSearchTrack } from '@disco/utils/tracks'

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useParams, useNavigate } from 'react-router-dom'
import type { GroupId } from 'types/group'
import type { PlaylistId } from 'types/playlist'
import type { TrackId } from 'types/track'
import DocumentHeadTags from 'components/document-head-tags'
import AddToPlaylistModal from 'components/modals/track/add-to-playlist'

const CopyToPlaylist = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams<{ trackId: string; originGroupId: string }>()

  const trackId = parseInt(params.trackId || '')
  const originGroupId = parseInt(params.originGroupId || '')
  const track = useSelector(state =>
    getTrack(state, {
      id: trackId,
    }),
  )
  const shortlists = useSelector(getShortlists)

  const handleClose = () => navigate('/')

  useEffect(() => {
    // fetch track details if we track playlists were not loaded previously
    if (track) return
    api
      .getTrack(trackId)
      .then(track => dispatch(loadBatch([track])))
      .catch(() => {})
  }, [track, trackId, dispatch])

  const handleCopyToPlaylist = (playlistIds: PlaylistId[]) => {
    if (!track) return
    const objectUrl = track.stream_url
    dispatch(
      copyToDisco(
        track.name,
        objectUrl,
        {
          playlistIds,
        },
        originGroupId,
        {
          Track_Name: track.name,
          Copy_To_Location: 'Playlist',
          Copy: 'Playlist',
          Type: 'Track',
          'Channel ID': originGroupId,
          MDS: isAggregatedSearchTrack(track),
        },
      ),
    )
    handleClose()
  }

  return (
    <>
      <DocumentHeadTags title="Copy to playlist | DISCO" />
      <AddToPlaylistModal
        type="copy"
        multi
        shortlists={shortlists}
        track={track}
        onClose={handleClose}
        onSubmit={handleCopyToPlaylist}
      />
    </>
  )
}

export default CopyToPlaylist
